import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'insurance-plan-learn-more',
    templateUrl: './insurance-plan-learn-more.component.html',
    styleUrls: ['./insurance-plan-learn-more.component.scss']
})
export class InsurancePlanLearnMoreComponent {
    @Output() openConsentModalChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    readonly constants = {
        HAND_HOLDING_DOLLAR_BACKGROUND_COLOR: '#F0F3F4',
        HAND_HOLDING_DOLLAR_IMAGE_URL: 'img/hand-holding-dollar.svg'
    };
}
